import { createRouter, createWebHashHistory } from 'vue-router'
import Home from '../views/Home.vue'
import Again from '../views/Again.vue'
import About from '../views/About.vue'
import Step from '../views/Step.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/about',
    name: 'About',
    component: About
  },
  {
    path: '/again',
    name: 'Again',
    component: Again
  },
  {
    path: '/step/:id',
    name: 'Step',
    component: Step
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
